import React, { useEffect, useState } from 'react';

import BoxGraphic from '../components/boxGraphic';
import BoxMonth from '../components/boxMonth';
import BoxEnd from '../components/boxEnd';

import Constants from '~/utils/constants';
import Container from '~/components/container';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import ContainerFlex from '~/components/containerFlex';
import Button from '~/components/button';
import { MdOutlineRefresh } from 'react-icons/md';
import TableList from '~/components/tableList';
import { AiFillCiCircle, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import * as S from '../styles';
import LoadingComponents from '~/components/loadingInComponents';
import moment from 'moment';
import Chart from 'react-apexcharts';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { FaCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { runDownloadTask } from '~/utils/runDownloadTask';

const customHeader = [
  {
    id: 1,
    value: 'Loja',
    maxChar: 25,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'Operador',
    maxChar: 25,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Data/hora abertura',
    maxChar: 25,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Tablet OK?',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Computador OK?',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Impressora OK?',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 7,
    value: 'Totem OK?',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Telefone OK?',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 9,
    value: 'Status',
    maxChar: 10,
    textAlign: 'center',
  },
];
const row = {
  loja: 'Loja 1',
  operador: 'Joao',
  datahora: new Date(),
  tablet: 'Sim',
  pc: 'Sim',
  impr: 'Sim',
  totem: 'Não',
  status: 'ABERTA',
};

const StoreOpenningDashboard: React.FC = () => {
  const { hasAnyRole } = useUserRole();
  const history = useHistory();
  const validateRoles = () =>
    hasAnyRole([
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ]);

  const GetOpeningData = useApi(
    Endpoints.graphc.getStoreOpeningDetails,
    ApiMethod.GET,
    {},
    true,
  );
  const GetReport = useApi(
    Endpoints.graphc.getStoreOpeningDetailsCsv,
    ApiMethod.GET,
    {},
    true,
  );
  const parseItem = (item) => {
    return item === '-' ? '*' : 'Ok';
  };
  const [tableItems, setTableItems] = useState([]);
  const [chartData, setChartData] = useState({
    open: [],
    closed: [],
    alert: [],
  });

  const getData = async () => {
    const response = await GetOpeningData.callApi({
      data: moment().format('DD/MM/YYYY'),
      pagina: 0,
      tamanho: 100,
    });
    const { data } = response?.data;

    const todosOsOperadores = data.flatMap(
      (loja) => loja.operadoresPresentes || [],
    );

    console.log(todosOsOperadores);

    let items = [];
    if (data?.length > 0) {
      setChartData({
        open: data?.filter((e) => ['ABERTA'].includes(e.status)),
        closed: data?.filter((e) => e.status === 'FECHADA'),
        alert: data?.filter((e) => e.status === 'ALERTA'),
      });
      data.forEach((row) => {
        const newItem = [
          {
            border: true,
            value: row?.nome,
            maxChar: 30,
            textAlign: 'center',
          },
          {
            border: true,
            value: row?.operador,
            maxChar: 10,
            textAlign: 'center',
          },
          {
            border: true,
            value: row?.dataHoraAbertura,
            maxChar: 20,
            textAlign: 'center',
          },
          {
            border: true,
            value: parseItem(row?.tabletOk),
            maxChar: 20,
            textAlign: 'center',
          },

          {
            border: true,
            value: parseItem(row?.computadorOk),
            maxChar: 15,
            textAlign: 'center',
          },
          {
            border: true,
            value: parseItem(row?.impressoraOk),
            maxChar: 15,
            textAlign: 'center',
          },
          {
            border: true,
            value: parseItem(row?.totemOk),
            maxChar: 30,
            textAlign: 'center',
          },
          {
            border: true,
            value: parseItem(row?.telefoneOk),
            maxChar: 20,
            textAlign: 'center',
          },
          {
            border: true,
            value:
              row.status === 'ABERTA' ? (
                <FaCircle style={{ color: 'green' }} />
              ) : row.status === 'ALERTA' ? (
                <FaCircle style={{ color: 'orange' }} />
              ) : (
                <FaCircle style={{ color: 'red' }} />
              ),
            maxChar: 30,
            textAlign: 'center',
          },
        ];

        items.push(newItem);
      });

      setTableItems(items);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  console.log(chartData, 'Teste');

  const onReportDownload = async () =>
    runDownloadTask(async () => {
      const response = await GetReport.callApi({
        data: moment().format('DD/MM/YYYY'),
      });
      if (response.data?.base64) {
        const link = document.createElement('a');
        link.href = 'data:text/csv;base64,' + response.data.base64;
        link.download = response.data.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  return (
    <Container title="Dashboard B.I.">
      {validateRoles() && (
        <>
          <ContainerFlex key="teste" center marginBottom={8} row space>
            <ContainerFlex
              onClick={() => getData()}
              role="button"
              style={{ cursor: 'pointer', width: 'fit-content', flex: 0 }}
              row
              center
              gap="4"
            >
              <span>Atualizar</span>
              <MdOutlineRefresh />
            </ContainerFlex>
            <ContainerFlex row gap={'12'} end>
              <Button fitContent onClick={onReportDownload}>
                Baixar relatório
              </Button>
              <Button onClick={() => history.goBack()} outlined fitContent>
                Voltar
              </Button>
            </ContainerFlex>
          </ContainerFlex>
          {/* Tabela de checklist */}
          <ContainerFlex
            style={{
              boxShadow: '0 10px 26px rgb(0 0 0 / 5%)',
              margin: '1rem 0rem',
              maxHeight: '300px',
              overflow: 'auto',
            }}
          >
            <LoadingComponents status={GetOpeningData.loading} />

            <TableList
              fixedHeader
              customerHeader={customHeader}
              list={tableItems}
            />
          </ContainerFlex>
          <ContainerFlex row gap="25">
            {/* Gráfico de lojas abertas/fechadas */}

            <S.EndCardsItemsNoHover>
              <LoadingComponents status={GetOpeningData.loading} />
              <header>
                <div className="title">
                  <h1>Loja</h1>
                  <span className="title__update">
                    {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                  </span>
                </div>
              </header>

              <section>
                <Chart
                  series={[
                    chartData?.open?.length,
                    chartData?.closed?.length,
                    chartData?.alert?.length,
                  ]}
                  type="pie"
                  options={{
                    stroke: { show: false },
                    colors: ['#008000', '#FF0000', '#ffa500'],
                    labels: ['Lojas abertas', 'Lojas fechadas', 'Alerta'],
                  }}
                />
              </section>
            </S.EndCardsItemsNoHover>

            {/* Numero de lojas abertas/fechadas */}
            {/* <ContainerFlex padding={12} gap="16" style={{ width: '50%' }}>
              <S.EndCardsItemsNoHover style={{ width: '70%'}}>
                <LoadingComponents status={GetOpeningData.loading} />
                <header>
                  <div className="title">
                    <h1>Lojas abertas</h1>
                    <span className="title__update">
                      {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                    </span>
                  </div>
                </header>

                <section>
                  <article>
                    <h2>
                      {chartData?.open?.length + chartData?.alert?.length}
                    </h2>
                  </article>
                </section>
              </S.EndCardsItemsNoHover>
              <S.EndCardsItemsNoHover style={{ width: '70%'}}>
                <LoadingComponents status={GetOpeningData.loading} />
                <header>
                  <div className="title">
                    <h1>Lojas fechadas</h1>
                    <span className="title__update">
                      {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                    </span>
                  </div>
                </header>

                <section>
                  <article>
                    <h2>{chartData?.closed?.length}</h2>
                  </article>
                </section>
              </S.EndCardsItemsNoHover>
            </ContainerFlex> */}
            {/* Detalhes de lojas abertas */}
            <ContainerFlex
              style={{
                boxShadow: '0 10px 26px rgb(0 0 0 / 5%)',
                padding: '1rem',
                overflow: 'auto',
                background: '#fff',
                borderRadius: '12px',
                height: 380,
                overflowY: 'auto',
              }}
            >
              <ContainerFlex>
                <span
                  style={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    marginBottom: '5px',
                    color: '#2e3958',
                  }}
                >
                  Check-in
                </span>

                <LoadingComponents status={GetOpeningData.loading} />

                {chartData.open.length > 0 || chartData.alert.length > 0 ? (
                  <>
                    <ContainerFlex
                      row
                      space
                      style={{
                        fontWeight: 'bold',
                        maxHeight: 25,
                        marginBottom: 10,
                      }}
                    >
                      <ContainerFlex flex={1}>
                        <span>Lojas abertas</span>
                      </ContainerFlex>
                      <ContainerFlex flex={1} align="center">
                        <span>Nome operador</span>
                      </ContainerFlex>
                      <ContainerFlex flex={1} align="flex-end">
                        <span>Horário Check-in</span>
                      </ContainerFlex>
                      <ContainerFlex flex={1} align="center">
                        <span>Status</span>
                      </ContainerFlex>
                    </ContainerFlex>
                    {chartData?.open?.length > 0 && (
                      <>
                        {chartData.open.map((store, index) => {
                          return (
                            <ContainerFlex
                              key={store.id}
                              row
                              space
                              align="center"
                              flex={0.2}
                              style={{ borderBottom: '1px solid #d3d3d3' }}
                            >
                              <ContainerFlex flex={1}>
                                <span title={store?.nome}>{store.nome}</span>
                              </ContainerFlex>

                              <ContainerFlex flex={1}>
                                {store?.operadoresPresentes?.map((operador) => (
                                  <ContainerFlex
                                    key={operador.idFuncionario}
                                    flex={0.2}
                                    align="flex-start"
                                    style={{ marginBottom: 0 }}
                                  >
                                    <span
                                      title={operador.nome}
                                      style={{
                                        display: 'inline-block',
                                        maxWidth: 200,
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      {operador?.nome}
                                    </span>
                                  </ContainerFlex>
                                ))}
                              </ContainerFlex>
                              <ContainerFlex>
                                {store?.operadoresPresentes?.map((operador) => (
                                  <ContainerFlex
                                    key={operador.idFuncionario}
                                    flex={1}
                                    align="center"
                                  >
                                    <span>
                                      {moment(
                                        operador?.horarioCheckIn,
                                        'YYYY-MM-DD HH:mm',
                                      ).format('HH:mm')}
                                    </span>
                                  </ContainerFlex>
                                ))}
                              </ContainerFlex>

                              <ContainerFlex flex={0.5} align="center" row>
                                {store.status === 'ABERTA' ? (
                                  <FaCircle style={{ color: 'green' }} />
                                ) : (
                                  <FaCircle style={{ color: 'red' }} />
                                )}
                              </ContainerFlex>
                            </ContainerFlex>
                          );
                        })}
                      </>
                    )}

                    {chartData.alert.length > 0 &&
                      chartData.alert.map((store) => {
                        return (
                          <ContainerFlex
                            key={store.id}
                            row
                            space
                            align="center"
                            flex={0.2}
                            style={{ borderBottom: '1px solid #d3d3d3' }}
                          >
                            <ContainerFlex flex={1}>
                              <span title={store?.nome}>{store.nome}</span>
                            </ContainerFlex>

                            <ContainerFlex>
                              {store?.operadoresPresentes?.map((operador) => (
                                <ContainerFlex
                                  key={operador.idFuncionario}
                                  flex={0.2}
                                  align="flex-start"
                                >
                                  <span
                                    title={operador.nome}
                                    style={{
                                      display: 'inline-block',
                                      maxWidth: 200,
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {operador?.nome}
                                  </span>
                                </ContainerFlex>
                              ))}
                            </ContainerFlex>

                            <ContainerFlex>
                              {store?.operadoresPresentes?.map((operador) => (
                                <ContainerFlex
                                  key={operador.idFuncionario}
                                  flex={1}
                                  align="center"
                                >
                                  <span>
                                    {moment(
                                      operador?.horarioCheckIn,
                                      'YYYY-MM-DD HH:mm',
                                    ).format('HH:mm')}
                                  </span>
                                </ContainerFlex>
                              ))}
                            </ContainerFlex>
                            <ContainerFlex flex={0.5} align="center" row>
                              {store.status === 'ALERTA' ? (
                                <FaCircle style={{ color: 'orange' }} />
                              ) : (
                                <FaCircle style={{ color: 'red' }} />
                              )}
                            </ContainerFlex>
                          </ContainerFlex>
                        );
                      })}
                  </>
                ) : (
                  <h2>Nenhuma loja aberta ainda</h2>
                )}
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex row gap="25" marginTop={20}>
            <ContainerFlex
              style={{
                boxShadow: '0 10px 26px rgb(0 0 0 / 5%)',
                padding: '1rem',
                overflow: 'auto',
                background: '#fff',
                borderRadius: '12px',
                height: 380,
                overflowY: 'auto',
              }}
            >
              <S.SpanHourUpdate>
                <div className="title">
                  <h1>Lojas abertas</h1>
                  <span className="title__update">
                    {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                  </span>
                </div>
              </S.SpanHourUpdate>
              <LoadingComponents status={GetOpeningData.loading} />

              {chartData.open.length > 0 ? (
                chartData?.open.map((store) => {
                  return (
                    <ContainerFlex
                      row
                      space
                      justifyContent="flex-start"
                      align="center"
                      flex={0.1}
                    >
                      <ContainerFlex flex={1}>
                        <span>{store.nome}</span>
                      </ContainerFlex>
                    </ContainerFlex>
                  );
                })
              ) : (
                <h2>Nenhuma loja aberta ainda</h2>
              )}
            </ContainerFlex>
            <ContainerFlex
              style={{
                boxShadow: '0 10px 26px rgb(0 0 0 / 5%)',
                padding: '1rem',
                overflow: 'auto',
                background: '#fff',
                borderRadius: '12px',
                height: 380,
                overflowY: 'auto',
              }}
            >
              <S.SpanHourUpdate>
                <div className="title">
                  <h1>Lojas fechadas</h1>
                  <span className="title__update">
                    {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                  </span>
                </div>
              </S.SpanHourUpdate>
              <LoadingComponents status={GetOpeningData.loading} />
              {chartData?.closed?.length > 0 ? (
                chartData?.closed?.map((store) => {
                  return (
                    <ContainerFlex
                      row
                      space
                      justifyContent="flex-start"
                      align="center"
                      flex={0.2}
                    >
                      <ContainerFlex flex={1}>
                        <span>{store.nome}</span>
                      </ContainerFlex>
                    </ContainerFlex>
                  );
                })
              ) : (
                <h2>Todas as lojas abertas</h2>
              )}
            </ContainerFlex>
            <ContainerFlex
              style={{
                boxShadow: '0 10px 26px rgb(0 0 0 / 5%)',
                padding: '1rem',
                overflow: 'auto',
                background: '#fff',
                borderRadius: '12px',
                height: 300,
                overflowY: 'auto',
              }}
            >
              <S.SpanHourUpdate>
                <div className="title">
                  <h1>Alerta</h1>
                  <span className="title__update">
                    {`Atualizado: hoje às ${moment().format('HH:mm')}`}
                  </span>
                </div>
              </S.SpanHourUpdate>
              <LoadingComponents status={GetOpeningData.loading} />

              {chartData.alert.length > 0 ? (
                chartData.alert.map((store) => {
                  return (
                    <ContainerFlex
                      row
                      space
                      justifyContent="flex-start"
                      align="center"
                      flex={0.1}
                    >
                      <ContainerFlex flex={1}>
                        <span>{store.nome}</span>
                      </ContainerFlex>
                    </ContainerFlex>
                  );
                })
              ) : (
                <h2>Nenhum alerta detectado</h2>
              )}
            </ContainerFlex>
          </ContainerFlex>
        </>
      )}
    </Container>
  );
};

export default StoreOpenningDashboard;
